import { useQuery } from '@tanstack/react-query';
import { milestonePhaseItemApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Milestone checklist items for a job, optionally narrowed to one phase. */
export function useMilestoneItems(
  jobId: number | null | undefined,
  phaseId: string | null = null,
) {
  return useQuery({
    queryKey: queryKeys.milestoneItems.forPhase(jobId ?? -1, phaseId),
    queryFn: ({ signal }) =>
      milestonePhaseItemApiClient.listPhaseItems(
        String(jobId),
        { phase: phaseId },
        toCancelToken(signal),
      ),
    enabled: jobId != null && jobId > 0,
    staleTime: 0,
    meta: { errorContext: 'milestone items' },
  });
}

export function useMilestoneItemLinks(
  jobId: number | null | undefined,
  itemId: string | null | undefined,
) {
  return useQuery({
    queryKey: queryKeys.milestoneItems.links(jobId ?? -1, itemId ?? ''),
    queryFn: ({ signal }) =>
      milestonePhaseItemApiClient.getLinks(
        jobId!,
        itemId!,
        toCancelToken(signal),
      ),
    enabled: jobId != null && jobId > 0 && !!itemId,
    staleTime: 30_000,
    meta: { errorContext: 'milestone item links' },
  });
}
